import type {SvelteComponentConstructor} from '../../../svelte/types';
import type {ValueEditorType} from '../types';


export class ValueEditorRegistrationService {
    public static serviceName = 'valueEditorRegistrationService';

    private editorTypeToComponentMap = new Map<ValueEditorType, SvelteComponentConstructor<any>>();

    public registerEditorComponent(type: ValueEditorType, editorComponent: SvelteComponentConstructor<any>): ValueEditorRegistrationService {
        this.editorTypeToComponentMap.forEach((value, key) => {
            if (key === type) {
                throw new Error(`Type '${type}' is already registered.`)
            }

            if (value === editorComponent) {
                throw new Error(`Value editor component '${editorComponent}' is already registered.`)
            }
        });

        this.editorTypeToComponentMap.set(type, editorComponent);
        return this;
    }

    public getEditorComponentForType(type: ValueEditorType): SvelteComponentConstructor<any> {
        if (!this.editorTypeToComponentMap.has(type)) {
            throw new Error(`Unknown value editor type: '${type}'`);
        }

        return this.editorTypeToComponentMap.get(type);
    }
}